// Description: Handles Fibonacci sequence to calculate backoff times and
// when attempting to reconnect the websocket
export class WebSocketReconnect {
    fib_a: number = 0;
    fib_b: number = 1;
    timeout: ReturnType<typeof setTimeout> | null = null;
    manually_closed: boolean = false;
    constructor(
        public max_delay: number = 5000, // NOTE: Point at which the sequence will stop growing.
        public multiplier: number = 100  // NOTE: to calculate the delay in ms - start with 100 by default
    ) { }

    // NOTE: Get next delay and set the class properties to new values
    public getNextDelay(): number {
        const fib_a = this.fib_a;
        const fib_b = this.fib_b;
        const delay = Math.min((fib_a + fib_b) * this.multiplier, this.max_delay);
        this.fib_a = fib_b;
        this.fib_b = Number(fib_a + fib_b);
        return delay;
    };
    // NOTE: Reset fib properties to new ones
    public resetBackoff() {
        this.fib_a = 0;
        this.fib_b = 1;
        if (!!this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    };

}
